<template>
	<div>
		<div class="div_licensePlate">
			<ul>
				<li v-for="(item,index) of inputList" :class="{'li_show':input_index == index}">
					<input
							:style="index > 0 ? 'color:#0d0d0d':''"
							type="text"
							maxlength="1"
							v-model="inputtext.substring(index,item)"
							@blur="animateWidth(index,'blur')"
							@focus="animateWidth(index,'focus')"
					/>
				</li>
			</ul>
		</div>
		<div class="div_check" @click="checkIsNewEnergy">
			<div class="div_left" :class="{'check':ifNewEnergy}">
				<img src="../../../common/img/check.png" alt/>
			</div>
			<p class="div_right">是否为新能源车牌</p>
		</div>
		<div id="keycontent" v-if="keycontentShow">
			<div id="keyboard">
				<div class="keyTitle" @click="button_close">关闭</div>
				<div class="keyContent">
					<ul>
						<li v-for="(nub,index) in list" :class="li_show(index,listType)" @click="keycontent_val(nub)" :key="index">
							<p>{{nub}}</p>
						</li>
					</ul>
					<div class="button_tab button" @click="listType=!listType">
						<div>切换</div>
					</div>
					<div class="button_delete button" @click="button_delete">
						<div>删除</div>
					</div>
				</div>
			</div>
			<!--<div id="keyMask" @click="button_close"></div>-->
		</div>
	</div>
</template>

<script>
    import plate from '@/utils/plate'
    export default {
        name: "plateInput",
		data (){
            return{
                input_index: 1,
                ifNewEnergy: false,
                list: [],
                inputtext: "",
                listType: true,
                keycontentShow: false,
                inputList: [1,2,3,4,5,6,7],
                licensePlate_provinces: plate.province,
                licensePlate_letter: plate.number,
			}
		},
        watch: {
            listType: function(val, oldval) {
                this.setList();
            }
        },
		mounted () {
            this.listType = true;
            this.setList();
		},
		methods: {
	


            li_show: function (index, type) {
                // console.log(index + "===" + type);
                if (type) {
                    if (index == 30) {
                        return "li_right";
                    }
                } else {
                    if (index == 20) {
                        return "li_left";
                    }
                    if (index == 29) {
                        return "li_right";
                    }
                }
            },
            setList () {
                if (this.listType) {
                    this.list = this.licensePlate_provinces;
                } else {
                    this.list = this.licensePlate_letter;
                }
            },
            animateWidth (index, type) {
                window.scrollTo(0,0);
                document.activeElement.blur();
                if (index == 0) {
                    if (type == "blur") {
                        this.input_index = 0;
                        console.log("移除省");
                    } else {
                        this.input_index = index;
                        console.log("移入省");
                        this.keycontentShow = true;
                        this.listType = true;
                    }
                } else if (index == 1) {
                    if (type == "blur") {
                        console.log("移除字母");
                        this.input_index = 0;
                    } else {
                        this.input_index = index;
                        console.log("移入字母");
                        this.keycontentShow = true;
                        this.listType = false;
                    }
                } else {
                    if (type == "blur") {
                        console.log("移除");
                        this.input_index = 0;
                    } else {
                        this.input_index = index;
                        console.log("移入");
                        this.keycontentShow = true;
                        this.listType = false;
                    }
                }
            },
            button_delete: function () {
                var t = [];
                if (this.ifNewEnergy) {
                    t = ["", "", "", "", "", "", "", ""];
                } else {
                    t = ["", "", "", "", "", "", ""];
                }
                var i = this.input_index;
                if (i - 1 != t.length) {
                    if (!this.ifNewEnergy) {
                        i--;
                    }
                }
                for (var j = 0; j < this.inputtext.split("").length; j++) {
                    t[j] = this.inputtext.split("")[j];
                }

                console.log(i);
                for (var j = 0; j < t.length; j++) {
                    if (j == i) {
                        t[j] = "";
                    }
                }
                this.inputtext = t.join("");
                console.log(t);
                this.input_index > 0 ? this.input_index-- : this.input_index;
                this.animateWidth(this.input_index, "focus");
                this.$emit('onChange',this.inputtext)
            },
            button_close: function () {
                this.keycontentShow = false;
            },
            keycontent_val: function (val) {
                var i = this.input_index;
                var t = [];
                if (this.ifNewEnergy) {
                    t = ["", "", "", "", "", "", "", ""];
                } else {
                    t = ["", "", "", "", "", "", ""];
                }

                for (var j = 0; j < this.inputtext.split("").length; j++) {
                    t[j] = this.inputtext.split("")[j];
                }

                console.log(i);
                for (var j = 0; j < t.length; j++) {
                    if (j == i) {
                        t[j] = val;
                    }
                }
                console.log(t);
                this.inputtext = t.join("");
                console.log(this.input_index);
                this.input_index < 7 ? this.input_index++ : this.input_index;
                this.animateWidth(this.input_index, "focus");
                this.$emit('onChange',this.inputtext)
            },
            checkIsNewEnergy() {
                this.ifNewEnergy = !this.ifNewEnergy;
                if (this.ifNewEnergy) {
                    this.inputList.push(8)
                }else {
                    this.inputList.pop()
                }
            },
		}
    }
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable';
	.div_licensePlate {
		margin: 15px;
		border: 1px solid $color-green;
		height: 44px;
		border-radius: 6px;
		overflow: hidden;

		ul {
			width: 100%;
			height: 100%;
			display: flex;
			padding: 0px;
			list-style: none;
			margin: 0px;

			li {
				height: 100%;
				border-left: 1px solid $color-green;
				flex: 1;
				position: relative;
				box-sizing: border-box;

				input {
					position: absolute;
					left: 0px;
					top: 0px;
					width: 100%;
					height: 44px;
					border: 0px;
					background: initial;
					font-size: 16px;
					text-align: center;
					font-weight: bold;
					line-height: 44px;
				}
			}

			.li_show {
				border-bottom: 2px solid #ffffff;
				animation: li_show 1.5s infinite linear;
			}

			@keyframes li_show {
				0% {
					border-bottom: 2px solid #ffffff;
				}

				50% {
					border-bottom: 0px;
				}

				100% {
					border-bottom: 2px solid #ffffff;
				}
			}

			li:nth-child(1) {
				border-left: 0px;
				background: $color-green;
				color: #ffffff;

				input {
					color: #ffffff;
				}
			}
		}
	}
	#keycontent {
		position: fixed;
		width: 100%;
		height: 40%;
		bottom: 0;
		left: 0;
		z-index: 3
		#keyboard {
			position: absolute;
			bottom: 0px;
			width: 100%;
			background-color: #d0d3d9;
			font-size: 14px;
			z-index: 9999;

			.keyTitle {
				height: 40px;
				line-height: 40px;
				font-size: 1em;
				text-align: right;
				background-color: #ffffff;
				border-top: 1px solid $color-green;
				color: #5495f6;
				padding: 0px 12px;
			}

			.keyContent {
				padding: 4px 2px 4px 2px;
				position: relative;

				ul {
					width: 100%;
					overflow: hidden;
					padding: 0px;
					list-style: none;
					margin: 0px;

					li {
						float: left;
						padding: 2px 2px;
						width: 10%;
						box-sizing: border-box;

						p {
							color #0d0d0d
							height: 45px;
							line-height: 45px;
							background-color: #ffffff;
							text-align: center;
							border-radius: 4px;
							font-size: 1em;
							box-shadow: 0px 2px 2px 0px rgb(152, 155, 160);
						}
					}

					.li_left {
						color #0d0d0d
						margin-left: 5%;
					}

					.li_right {
						color #0d0d0d
						margin-left: 15%;
					}
				}

				.button {
					padding: 2px 2px;
					width: 13%;

					div {
						height: 45px;
						line-height: 45px;
						background-color: #a8b0bc;
						text-align: center;
						border-radius: 4px;
						font-size: 1em;
						box-shadow: 0px 2px 2px 0px rgb(152, 155, 160);
					}
				}

				.button_tab {
					position: absolute;
					left: 2px;
					bottom: 4px;
				}

				.button_delete {
					position: absolute;
					right: 2px;
					bottom: 4px;
				}
			}
		}

		#keyMask {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0px;
			left: 0px;
			z-index: 1;
		}
	}
	.div_check {
		margin: 15px;
		display: flex;
		flex-direction: row;
		align-items: center;

		.div_left {
			height: 20px;
			width: 20px;
			border: 1px solid #dddddd;
			margin-right: 8px;

			img {
				width: 100%;
				height: 100%;
				display: none;
			}
		}

		.check {
			border: 0px;

			img {
				display: block;
			}
		}

		.div_right {
			color #0d0d0d
			font-size: 16px;
		}
	}
</style>
